<template>
  <v-data-table
    :headers="headersClienteEst"
    disable-pagination
    hide-default-footer
    class="elevation-1 tbl_datos"
    :items="ItemClienteEst"
    dense
    id="tbl_datos"
    v-if="$vuetify.breakpoint.mdAndUp"
  >
    <template v-slot:top>
      <v-row no-gutters class="mt-5">
        <v-col cols="12" sm="12" md="2">
          <v-select
            :items="aniosChange"
            filled
            v-model="selectAnio"
            label="Año"
            dense
            single-line
            hide-details
            @change="estadisticas"
            style="width: 120px"
            class="mx-auto"
          ></v-select>
        </v-col>
      </v-row>
    </template>
    <template v-slot:[`item.NombreMes`]="{ item }">
      <span class="black--text subtitle-2 font-weight-bold">
        {{ item.NombreMes }}</span
      >
    </template>
    <template v-slot:[`item.Compras`]="{ item }">
      <span class="black--text subtitle-2 font-weight-bold">
        {{ simboloMoneda[tipoMoneda] }}
        {{ item.Compras[tipoMoneda] | numeral("0,0.00") }}
      </span>
    </template>
    <template v-slot:[`item.Cobros`]="{ item }">
      <span class="black--text subtitle-2 font-weight-bold">
        {{ simboloMoneda[tipoMoneda] }}
        {{ item.Cobros[tipoMoneda] | numeral("0,0.00") }}
      </span>
    </template>
    <template v-slot:[`item.CheqDev`]="{ item }">
      <span class="black--text subtitle-2 font-weight-bold">
        {{ item.CheqDev | nocero }}</span
      >
    </template>
    <template v-slot:[`item.DiasMora`]="{ item }">
      <span class="black--text subtitle-2 font-weight-bold">
        {{ item.DiasMora | nocero }}
      </span>
    </template>
    <template v-slot:[`item.DocMora`]="{ item }">
      <span class="black--text subtitle-2 font-weight-bold">
        {{ item.DocMora | nocero }}
      </span>
    </template>
    <template v-slot:[`item.PromedMora`]="{ item }">
      <span class="black--text subtitle-2 font-weight-bold">
        {{ item.PromedMora | nocero }}
      </span>
    </template>
    <template slot="body.append">
      <tr>
        <th></th>
        <th
          class="
            subtitle-2
            text-right
            grey--text
            text--darken-4
            font-weight-bold
            text-no-wrap
          "
        >
          <span
            v-if="$vuetify.breakpoint.smAndDown"
            class="font-weight-bold caption"
            >Compras USD</span
          >
          {{ simboloMoneda[tipoMoneda] }}
          {{ ItemClienteInfo(`TCompras`) | numeral("0,0.00") }}
        </th>
        <th
          class="
            subtitle-2
            text-right
            grey--text
            text--darken-4
            font-weight-bold
            text-no-wrap
          "
        >
          <span
            v-if="$vuetify.breakpoint.smAndDown"
            class="font-weight-bold caption"
            >Pagos USD</span
          >
          {{ simboloMoneda[tipoMoneda] }}
          {{ ItemClienteInfo(`TPagos`) | numeral("0,0.00") }}
        </th>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";

export default {
  data() {
    return {
      headersClienteEst: [
        {
          text: "Mes",
          align: "left",
          value: "NombreMes",
          width: "200px",
          sortable: false,
          divider: true,
          class: "black--text subtitle-1 font-weight-regular",
        },
        {
          text: "Compras USD",
          width: "200px",
          align: "right",
          value: "Compras",
          sortable: false,
          divider: true,
          class: "black--text subtitle-2 font-weight-regular",
        },
        {
          text: "Pagos USD",
          align: "right",
          value: "Cobros",
          width: "200px",
          sortable: false,
          divider: true,
          class: "black--text subtitle-2 font-weight-regular",
        },

        {
          text: "Doc Mora",
          align: "right",
          value: "DocMora",
          // width: "100px",
          sortable: false,
          divider: true,
          class: "black--text subtitle-2 font-weight-regular",
        },
        {
          text: "Promedio Mora",
          align: "right",
          value: "PromedMora",
          // width: "100px",
          sortable: false,
          divider: true,
          class: "black--text subtitle-2 font-weight-regular",
        },
      ],
    };
  },
  methods: {
    ...mapActions(["get_dsEstadistica"]),
    ...mapMutations(["set_anioEstaClie"]),
    async estadisticas() {
      // await this.set_GrupoCli(0);
      //this.clr_dsEstadistica();

      await this.get_dsEstadistica({
        opc: 4,
        anio: this.selectAnio,
        vergrupo:
          this.Cliente.data.GrupoCliente == 1 ? (this.verconsol ? 1 : 0) : 0,
      });
    },
  },
  filters: {
    nocero: function (value) {
      return parseInt(value) != 0 ? value : "";
    },
  },
  props:{
verconsol:Boolean
  },
  computed: {
    ...mapState([
      "Cliente",
      "simboloMoneda",
      "tipoMoneda",
      "dsEstadistica",
      "anioEstaClie"
    ]),
    ItemClienteInfo: function () {
      return function (idKey) {
        let xMonto = [];
        if (Object.entries(this.dsEstadistica).length !== 0) {
          let { ttestinfo: ttestinfo } = this.dsEstadistica.dsEstadistica;

          if (Object.entries(ttestinfo).length !== 0) {
            xMonto = ttestinfo[0][idKey][this.tipoMoneda];
          }
        }
        return xMonto;
      };
    },
    aniosChange() {
      let item = [],
        arrayF = [];
      if (Object.entries(this.dsEstadistica).length !== 0) {
        item = this.dsEstadistica.dsEstadistica.ttestinfo[0].Anios;
        arrayF = item.split([","]);
      }
      return arrayF;
      //dsEstadistica.dsEstadistica.ttestinfo[0].Anios
    },
    ItemClienteEst() {
      let xData = [];
      if (Object.entries(this.dsEstadistica).length !== 0) {
        let { ttestcli } = this.dsEstadistica.dsEstadistica;
        if (ttestcli !== undefined) xData = ttestcli;
      }
      return xData;
    },
    selectAnio: {
      get() {
        return this.anioEstaClie
      },
      set(val) {
        this.set_anioEstaClie(val)
      },
    },
  },
};
</script>
<style>
#tbl_datos tr:nth-child(odd) {
  background: #ffffff;
  border-left: 2px solid #fe5000;
}
#tbl_datos tr:nth-child(even) {
  background: #eeeeee;
  border-left: 2px solid #002f6c;
}
</style>
